export default __webpack_public_path__ + "static/media/25.39c1ec53.jpg";